import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Copy, Handshake } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const dataIt = (iso) => (iso ? new Date(iso).toLocaleDateString("it-IT") : "—");

export const PartnerGestione = () => {
  const [lista, setLista] = useState(null);
  const load = () => axios.get(`${API}/admin/partner`).then((r) => setLista(r.data)).catch(() => setLista([]));
  useEffect(() => { load(); }, []);
  const link = `${window.location.origin}/partner/youtire/`;
  const toggle = async (p) => { await axios.put(`${API}/admin/partner/${p.id}`, null, { params: { attivo: !p.attivo } }); load(); };

  return (
    <section className="mt-12" data-testid="partner-section">
      <h2 className="font-display text-2xl font-bold text-xmove-ink">Partner YouTire</h2>
      <p className="mt-1 text-sm text-xmove-muted">Ogni gommista si registra da solo con la propria email e da lì invia le richieste dei clienti: ogni richiesta arriva a te, finisce in "Richieste ricevute" con l'etichetta dell'officina e il gommista riceve una email di conferma.</p>
      <div className="mt-3 flex flex-wrap items-center gap-2 rounded-xl bg-xmove-cream p-3 text-xs">
        <Handshake size={14} className="text-xmove-orange" /> Link da inviare ai gommisti: <code className="rounded bg-white px-2 py-1" data-testid="partner-link">{link}</code>
        <button onClick={() => { navigator.clipboard.writeText(link); toast.success("Link copiato."); }} className="text-xmove-muted hover:text-xmove-orange" title="Copia"><Copy size={13} /></button>
      </div>
      <ul className="mt-4 space-y-2" data-testid="partner-lista">
        {lista === null ? <li className="text-sm text-xmove-muted">Caricamento…</li> : lista.length === 0 ? <li className="text-sm text-xmove-muted">Nessuna officina registrata ancora.</li> : lista.map((p) => (
          <li key={p.id} className={`flex flex-wrap items-center gap-3 rounded-xl border bg-white p-3 ${p.attivo ? "border-xmove-ink/8" : "border-dashed opacity-60"}`} data-testid={`partner-row-${p.id}`}>
            <div className="min-w-[220px] flex-1">
              <p className="text-sm font-bold text-xmove-ink">{p.officina}{p.citta ? ` · ${p.citta}` : ""}</p>
              <p className="text-[11px] text-xmove-muted">{p.referente} · {p.email} · {p.telefono} · registrata il {dataIt(p.creato_il)}</p>
            </div>
            <span className="rounded-full bg-xmove-night px-2.5 py-0.5 text-[11px] font-bold text-white" data-testid={`partner-richieste-${p.id}`}>{p.richieste || 0} richieste</span>
            <button onClick={() => toggle(p)} data-testid={`partner-toggle-${p.id}`} className="rounded-lg border border-xmove-ink/15 px-3 py-1.5 text-xs font-bold hover:border-xmove-orange">{p.attivo ? "Disattiva" : "Riattiva"}</button>
          </li>
        ))}
      </ul>
    </section>
  );
};
